/* Native scrolling for alternatives only; curated pairings remain a visible grid. */
(() => {
  if (customElements.get('rm-explore-rail')) return;
  class ExploreRail extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.connect()); }
    connect() {
      if (!this.isConnected || this.listeners) return;
      this.list = this.querySelector('.rm-discovery__grid');
      this.controls = this.querySelector('[data-explore-controls]');
      if (!this.list || !this.controls) return;
      this.previous = this.querySelector('[data-explore-prev]');
      this.next = this.querySelector('[data-explore-next]');
      this.range = this.querySelector('[data-explore-range]');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.previous.addEventListener('click', () => this.step(-1), options);
      this.next.addEventListener('click', () => this.step(1), options);
      this.list.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 100);
      }, { ...options, passive: true });
      this.list.addEventListener('keydown', event => {
        if (event.target !== this.list || event.altKey || event.ctrlKey || event.metaKey) return;
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.move(event.key === 'Home' ? 0 : this.list.scrollWidth);
        } else {
          const rtl = getComputedStyle(this.list).direction === 'rtl';
          this.step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.list);
      } else {
        window.addEventListener('resize', () => this.update(), options);
      }
      this.update();
    }
    position() { return Math.abs(this.list.scrollLeft); }
    move(position) {
      const maximum = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      this.list.scrollTo({
        left: Math.min(maximum, Math.max(0, position)) * (rtl ? -1 : 1),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    step(direction) {
      const card = this.list.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      if (!stride) return;
      const count = Math.max(1, Math.floor((this.list.clientWidth + gap + 1) / stride));
      this.move(this.position() + direction * stride * count);
    }
    update() {
      const cards = [...this.list.children];
      const maximum = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
      this.controls.hidden = maximum <= 2 || !cards.length;
      this.list.tabIndex = maximum > 2 ? 0 : -1;
      this.previous.setAttribute('aria-disabled', String(this.position() <= 2));
      this.next.setAttribute('aria-disabled', String(this.position() >= maximum - 2));
      const box = this.list.getBoundingClientRect();
      const visible = cards.map((card, index) => {
        const rect = card.getBoundingClientRect();
        return { index, amount: Math.max(0, Math.min(box.right, rect.right) - Math.max(box.left, rect.left)), width: rect.width };
      }).filter(card => card.width && card.amount >= card.width * .8);
      if (visible.length) {
        const first = visible[0].index + 1, last = visible[visible.length - 1].index + 1;
        const value = first === last ? `${first} of ${cards.length}` : `${first}–${last} of ${cards.length}`;
        if (this.range.textContent !== value) this.range.textContent = value;
      }
    }
    disconnectedCallback() {
      this.listeners?.abort(); this.listeners = null;
      this.resize?.disconnect(); clearTimeout(this.scrollTimer);
    }
  }
  customElements.define('rm-explore-rail', ExploreRail);
})();
